import ExcelJS from "exceljs";
import {saveAs} from 'file-saver';
import {Notification} from 'element-ui';

export const excelParent = {

    exportExcel: async (data) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Danh sách phụ huynh');

        // Gọi các hàm để cấu hình, thêm dữ liệu và áp dụng style
        excelParent.configureColumns(worksheet);
        excelParent.addData(worksheet, data);
        excelParent.applyStyles(worksheet);

        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            saveAs(blob, 'Danh_Sach_Phu_Huynh_Nhieu_Con.xlsx');
            Notification({
                title: 'Thành công',
                message: 'Xuất file Excel thành công!',
                type: 'success',
                duration: 3000,
            });
        } catch (error) {
            Notification({
                title: 'Lỗi',
                message: 'Lỗi xuất file Excel',
                type: 'warning',
                duration: 3000,
            });
        }
    },

    configureColumns: (worksheet) => {
        worksheet.columns = [
            {header: "STT", key: "index", width: 10},
            {header: "Họ và tên phụ huynh", key: "name", width: 40},
            {header: "Số điện thoại", key: "phone", width: 30},
            {header: "Đang học", key: "status_study", width: 20},
            {header: "Chờ học", key: "status_waiting", width: 20},
            {header: "Bảo lưu", key: "status_reserve", width: 20},
            {header: "Nghỉ học", key: "status_leave", width: 20},
            {header: "Ra trường", key: "status_out", width: 20},
            {header: "Tổng số con", key: "number_children", width: 20},
            {header: "Chi tiết", key: "detail_children", width: 60}
        ];
    },

    addData: (worksheet, data) => {
        data.forEach((parent, index) => {
            const detailChildren = parent.children
                .map((children, index) => `${index === 0 ? '\n' : ''}- ${children.fullName} (${children.className} - ${excelParent.formatStatusKid(children.statusKids)}) ${index === parent.children.length - 1 ? '\n' : ''}`)
                .join('\n')

            const row = {
                index: index + 1,
                name: parent.nameRepresentation,
                phone: parent.numberPhone,
                number_children: parent.numberOfChildren,
                detail_children: detailChildren,
            };

            if (parent.kidsStudying.numberKidsStatus > 0) {
                row.status_study = parent.kidsStudying.numberKidsStatus;
            }
            if (parent.kidsWaitingToLearn.numberKidsStatus > 0) {
                row.status_waiting = parent.kidsWaitingToLearn.numberKidsStatus;
            }
            if (parent.kidsReserve.numberKidsStatus > 0) {
                row.status_reserve = parent.kidsReserve.numberKidsStatus;
            }
            if (parent.kidsLeaveSchool.numberKidsStatus > 0) {
                row.status_leave = parent.kidsLeaveSchool.numberKidsStatus;
            }
            if (parent.kidsOutSchool.numberKidsStatus > 0) {
                row.status_out = parent.kidsOutSchool.numberKidsStatus;
            }

            worksheet.addRow(row);
        })
    },

    applyStyles: (worksheet) => {
        const headerRow = worksheet.getRow(1);

        // Căn giữa toàn bộ dữ liệu
        worksheet.eachRow((row) => {
            row.font = {name: 'Arial', size: 12};
            row.alignment = {vertical: 'middle', horizontal: 'center'};

            row.getCell("detail_children").alignment = { wrapText: true };
            row.getCell("name").alignment = {vertical: 'middle', horizontal: 'left'};
        });

        // Style cho header
        worksheet.columns.forEach((column, index) => {
            const cell = headerRow.getCell(index + 1);

            // Style cho ô header
            cell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' }};
            cell.alignment = { horizontal: 'center', vertical: 'middle'};
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: {argb: '78a5e7'},
            };

            cell.border = {
                left: { style: 'thin', color: { argb: 'FFFFFFFF' } },  // Đường viền bên trái màu trắng
                right: { style: 'thin', color: { argb: 'FFFFFFFF' } }, // Đường viền bên phải màu trắng
            };
        });
        headerRow.height = 20;
    },

    formatStatusKid: (status) => {
        switch (status) {
            case "STUDYING":
                return "Đang học";
            case "STUDY_WAIT":
                return "Chờ học";
            case "RESERVE":
                return "Bảo lưu";
            case "LEAVE_SCHOOL":
                return "Nghỉ học";
            case "OUT_SCHOOL":
                return "Ra trường";
        }
    }
}